import React from "react";

export default function CustomPrice({ optionsUtility: { customPrice } }) {
  return customPrice > 0 ? (
    <div id="option_total">
      <input type="hidden" id="raw_option_total"></input>
      <div id="option-display-total-format">
        Selection will add
        <span id="formatted_option_total">
          {" "}
          $<span id="updateTotal">{parseFloat(customPrice).toFixed(2)} </span>
        </span>
        to the price.
      </div>
    </div>
  ) : (
    <></>
  );
}
